import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
interface ReadClusterState {
  readClusterData: any[];
}

// initial states
const initialState: ReadClusterState = {
  readClusterData: [],
};

const reducers = {
  setReadClusterData: (
    state: ReadClusterState,
    action: PayloadAction<any[]>
  ) => {
    state.readClusterData = action.payload;
  },
};

// creating read cluster slice
const ReadClusterSlice = createSlice({
  name: "readCluster",
  initialState,
  reducers,
});

// exporting actions
export const { setReadClusterData } = ReadClusterSlice.actions;

export default ReadClusterSlice.reducer;
